import { translations } from './translations';

export function useTranslate() {
  return (key) => translations[key] || key;
}
